<template>
  <a class="kb-base-link" :href="href" v-bind="linkProps">
    <slot></slot>
  </a>
</template>

<script>
/**
 * Just a simple link.
 *
 * It is totaly fine to not use this component, and use a plain a tag instead. This component
 * is good in cases where you find yourself wanting to pass a-attributes as object.
 */
export default {
  name: 'kb-base-link',
  props: {
    /**
     * The link, the link should link to.
     */
    href: {
      type: String,
      required: true,
    },
    /**
     * Additional attributes for the a-tag.
     */
    linkProps: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.kb-base-link {
  color: $cTextPrimary;
}
</style>